import { HeaderComponent } from './../../components/header/header.component';
import { CommonModule, Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent } from '@components/button/button.component';
import { LinkComponent } from '@components/link/link.component';
import { ClaimSummaryComponent } from '@components/my-claims/claim-summary/claim-summary.component';
import { ScoreBoxComponent } from '@components/my-claims/score-box/score-box.component';
import { TranslateModule } from '@ngx-translate/core';
import { Claim } from 'app/interfaces/claim.interface';
import { ApiService } from 'app/services/api.service';
import { ClaimService } from 'app/services/claim.service';
import { LoadingService } from 'app/services/loading.service';

@Component({
    selector: 'app-claim-detail-page',
    templateUrl: './claim-detail.component.html',
    styleUrl: './claim-detail.component.scss',
    standalone: true,
    imports: [CommonModule, ButtonComponent, LinkComponent, ClaimSummaryComponent, HeaderComponent, TranslateModule, ScoreBoxComponent],
})
export class ClaimDetailComponent {
    @ViewChild(ClaimSummaryComponent) summaryComponent: ClaimSummaryComponent;

    claim: Claim
    id: string
    currentTab: string

    constructor(private location:Location, private api: ApiService, private router: Router, private route: ActivatedRoute, private loadingService: LoadingService, private claimService: ClaimService) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.id = params['id']
            this.fetchClaim()
        })
    }

    fetchClaim() {
        this.loadingService.show()
        this.api.getClaim(this.id).subscribe((claim) => {
            this.claim = claim
            this.loadingService.hide()
        })
    }

    goBack() {
        this.location.back()
    }

    switchToComments() {
        if(this.summaryComponent){
            this.summaryComponent.setCurrentTab('COMMENTS')
        }
    }
}
